import axios from 'axios';

import client from '../app/utils/auth-client';
import constants from '../app/config/constants';

/* eslint-disable import/prefer-default-export */
import { uploadImage } from '../app/utils/uploadFile';
// export const createSource = async (name, description) => {
//   const token = (await Auth.currentSession()).getIdToken().getJwtToken();
//   try {
//     const result = await API.post('tv', '/sources', {
//       headers: {
//         Authorization: `Bearer ${token}`
//       },
//       body: {
//         name,
//         description
//       }
//     });

//     return result.data.sourceId;
//   } catch (e) {
//     return false;
//   }
// };

export const getUsers = async () => {
  const token = await client.getToken();
  const result = await axios.get(`${constants.baseUrl}/users`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return result.data.data;
};

export const createUser = async body => {
  try {
    const token = await client.getToken();
    const result = await axios.post(`${constants.baseUrl}/users`, body, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return result.data;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
};

export const getSignedUrl = async body => {
  try {
    const token = await client.getToken();
    const result = await axios.post(`${constants.baseUrl}/drivers/upload`, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      body
    });

    return result.data;
  } catch (error) {
    return error.response.data;
  }
};

export const getSignedUrlToPushInS3 = async file => {
  try {
    const result = await getSignedUrl({
      fileType: `.${file.name.split('.').pop()}`
    });

    if (result.statusCode === 400) {
      return result;
    }

    return uploadImage(result.signedUrl, file).then(res => {
      return result;
    });
  } catch (error) {
    console.log(error);
    return error;
  }
};

/**
 * Get all drivers
 */
export const getDrivers = async () => {
  const token = await client.getToken();
  const result = await axios.get(`${constants.baseUrl}/users/drivers`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });

  return result.data.data;
};

export const getFirstMileDrivers = async () => {
  const token = await client.getToken();
  const result = await axios.get(
    `${constants.baseUrl}/users/drivers/firstmile`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return result.data.data;
};

/**
 * Get user info
 */
export const getMe = async () => {
  const token = await client.getToken();

  try {
    const result = await axios.get(`${constants.baseUrl}/users/me`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return result.data.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};

/**
 * Update user info
 */
export const updateUser = async (id, body) => {
  const token = await client.getToken();

  try {
    const result = await axios.put(`${constants.baseUrl}/users/${id}`, body, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return result.data;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
};

/**
 * Get all drivers consolidated (only drivers role 2)
 */
export const getDriversConsolidated = async () => {
  const token = await client.getToken();
  const result = await axios.get(
    `${constants.baseUrl}/users/drivers/consolidated`,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );

  return result.data.data;
};

/**
 * export users in bulk
 */

export const getBulkUsers = async body => {
  try {
    const token = await client.getToken();
    const result = await axios.post(
      `${constants.baseUrl}/users/drivers/export`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
    return result.data;
  } catch (error) {
    console.log(error);
    return error.response.data;
  }
};

/**
 * get info user by id
 */
export const getUserById = async id => {
  const token = await client.getToken();

  try {
    const result = await axios.get(`${constants.baseUrl}/users/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return result.data;
  } catch (error) {
    console.log(error);
    return null;
  }
};
